import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSession } from "@hooks/useSession";
import axios from "@api/axios";

const useDeleteData = (baseUrl, queryKey) => {
  const { token } = useSession();
  const queryClient = useQueryClient();

  const mutationFn = async (id) => {
    const response = await axios.delete(`${baseUrl}/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
};

export default useDeleteData;
